import { PublicUser } from "../../types";

const getUserFullName = (user?: PublicUser): string => {
  if (user) {
    return `${user.firstName} ${user.lastName}`;
  }
  return "[undefined]";
};

export default getUserFullName;
